import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

export const sortByComment = (list: IProfilingCode[]): IProfilingCode[] =>
  list.sort((a, b) => {
    const commentA = a.comment || ''
    const commentB = b.comment || ''

    return commentB.localeCompare(commentA)
  })
